import { GridRowModel } from '@mui/x-data-grid';
import { AclEntriesCommonTooltip } from 'common/components/sharedCustomComponents/AclEntriesCommonTooltip/AclEntriesCommonTooltip';
import {
    ActionDefinition,
    ColumnDefinition,
    ColumnType,
    Operations } from 'common/types/TypeDefs';

const ACTIONS_COLUMN: ColumnDefinition = {
    columnId: 'actions',
    columnName: 'Action',
    size: 0.4,
    columnType: ColumnType.Action,
    sortable: false
};

const DEFAULT_USER_PROFILE_ACL_ENTRIES_COLUMNS: ColumnDefinition[] = [
    { columnId: 'resourceTableName', columnName: 'Resource', columnType: ColumnType.First, copy: false },
    { columnId: 'conditionsToDisplay', columnName: 'Condition', columnType: ColumnType.Tooltip, copy: false },
    { columnId: 'aclAccessName', columnName: 'Access', columnType: ColumnType.Tooltip, copy: false },
    { columnId: 'userGroupName', columnName: 'Inheritance', columnType: ColumnType.Tooltip, copy: false, headerPrompt: 'Inherited items cannot be deleted' },
];

const USER_PROFILE_ACL_ENTRIES_WITH_LICENSE_INFO: ColumnDefinition[] = [
    { columnId: 'startDate', columnName: 'Start Date', columnType: ColumnType.DatetimeTooltip, size: 0.6 },
    { columnId: 'endDate', columnName: 'End Date', columnType: ColumnType.DatetimeTooltip, size: 0.6 },
    { columnId: 'licenseBillingRecord', columnName: 'License', columnType: ColumnType.Tooltip },
    {
        columnId: 'status',
        columnName: 'Status',
        columnType: ColumnType.Chip,
        size: 90,
        copy: false,
        sortable: false,
        toolTip: AclEntriesCommonTooltip
    }
];

export const _createUserProfileAclEntriesDataGridColumns = (
    isLicenseRequired?: boolean
): ColumnDefinition[] => isLicenseRequired ?
    [
        ...DEFAULT_USER_PROFILE_ACL_ENTRIES_COLUMNS,
        ...USER_PROFILE_ACL_ENTRIES_WITH_LICENSE_INFO,
        ACTIONS_COLUMN
    ] :
    [...DEFAULT_USER_PROFILE_ACL_ENTRIES_COLUMNS, ACTIONS_COLUMN];

export const _createUserProfileAclEntriesActionDefinitions = (
    disableDeleteCallback: (row: GridRowModel) => boolean,
    disableEditCallback: (row: GridRowModel) => boolean,
    disabledOpenLicenseCallback: (row: GridRowModel) => boolean,
    disabledOpenUserGroupCallback: (row: GridRowModel) => boolean,
    getLicenseUrl: (id: string, row?: GridRowModel) => string,
    getUserGroupUrl: (id: string, row?: GridRowModel) => string
): ActionDefinition[] => {
    const actionDefinitions =  [
        { action: Operations.OpenLicense, disabled: disabledOpenLicenseCallback, urlToOpen: getLicenseUrl },
        { action: Operations.OpenUserGroup, disabled: disabledOpenUserGroupCallback, urlToOpen: getUserGroupUrl },
        { action: Operations.Edit, disabled: disableEditCallback },
        { action: Operations.Delete, disabled: disableDeleteCallback },
    ] as ActionDefinition[];

    return actionDefinitions;
};
